<template>
    <audio :ref="meta.key" :class="[{ 'has': value && base.Util().validate(String(value)) }]" controls></audio>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Audio',
    props: ['meta', 'vm'],
    inject: ['base'],
    data() {
        return {
            value: this.vm || ''
        }
    },
    watch: {
        vm(newVM, oldVM) {
            if (this.value !== this.vm) {
                this.value = this.vm
                this.load()
            }
        },
        value(newValue, oldValue) {
            this.$emit('onchange', {
                value: String(this.value),
                hint: '',
                error: false
            })
        }
    },
    methods: {
        load() {
            this.base.API().download(this.value, (response) => {
                this.$refs[this.meta.key].src = URL.createObjectURL(new Blob([response.data], { type: 'audio/mp3' }))
            }, (error) => {
            })
        }
    }
}
</script>

<style scoped src="../../../assets/css/components/inputs/audio.css"></style>